<!--课程管理-->
<!--发布课程管理-->
<template>
  <div class="app-container">
    <!--查询条件区域-->
    <div class="title-container" shadow="never">
      <div class="title-con">
        <i class="el-icon-search"></i>
        <span style="margin-left: 5px;">筛选搜索</span>
      </div>
    </div>
    <el-card class="operate-container" shadow="never" style="margin-top: 0px;">
      <div class="filter-container" style="margin-top: 10px">
        <el-form :inline="true" :model="queryParam" label-width="120px">
          <el-form-item label="课程模板名:">
            <el-select v-model="queryParam.optionsLTValue" placeholder="请选择">
              <el-option
                v-for="item in queryParam.optionsLT"
                :key="item.id"
                :label="item.type"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="店铺名:">
            <el-input v-model="queryParam.storeFrontName" placeholder="输入店铺名"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="button-container" style="margin-top: 0px">
        <el-button type="warning" size="medium" class="operator-btn2" icon="el-icon-refresh" @click="handleResetSearch()">重 置</el-button>
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search" @click="onBtnSearch()">查 询</el-button>
      </div>
    </el-card>

    <div class="title-container" shadow="never" style="margin-top: 10px;">
      <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px;">数据列表</span>
      </div>
      <div>
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-circle-plus-outline" @click="handleCreateOneShowDlg()">店铺添加课程模板</el-button>
      </div>
    </div>
    <div class="table-container" style="margin-top: 0px;">
      <el-table ref="tableData"
                :data="tableData"
                v-loading="listLoading" border
                highlight-current-row
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}">
        <el-table-column type="selection" width="80"></el-table-column>
        <el-table-column prop="storeFrontName" label="店铺名" ></el-table-column>
        <el-table-column prop="lessonTemplateName" label="课程模板" ></el-table-column>
        <el-table-column prop="payTime" label="支付时间" ></el-table-column>
        <el-table-column prop="validityStartTime" label="有效期起始时间" ></el-table-column>
        <el-table-column prop="validityEndTime" label="有效期结束时间" ></el-table-column>
        <el-table-column prop="totalPayMoney" label="购买价格(元)" ></el-table-column>
        <el-table-column prop="score" label="课程评分" ></el-table-column>
        <el-table-column prop="statuDes" label="状态" ></el-table-column>
        <el-table-column label="操作" width="300">
          <template slot-scope="scope">
            <el-button @click.native.prevent="showVisibleDlgStatu(scope.$index, tableData)" type="warning" plain size="small">修改状态</el-button>
            <el-button @click.native.prevent="showVisibleDlgrenewal(scope.$index, tableData)" type="primary" plain size="small">续期</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="queryParam.pageNum"
        :page-size="queryParam.pageSize"
        :page-sizes="queryParam.pageSizes"
        :total="queryParam.totalPage">
      </el-pagination>
    </div>
    <!--    添加-->
    <el-dialog
      title="店铺添加课程模板"
      :visible.sync="visibleDlgAdd"
      width="50%"
      center>
      <div class="edit-area">
        <el-form label-width="150px">
          <el-form-item label="店铺负责人账号:">
            <el-input v-model="createParam.account" placeholder="输入账号" style="width: 300px;"></el-input>
            <el-button style="margin-left: 10px;margin-top: 5px" type="info" size="mini" @click="handleSearchAccount()">搜索</el-button>
          </el-form-item>
          <el-form-item label="店铺名:">
            <el-input v-model="createParam.storeTitle" placeholder="输入店铺名" :readonly="true" style="width: 300px;"></el-input>
          </el-form-item>
          <el-form-item label="课程模板:">
            <el-select v-model="createParam.optionsLTValue" placeholder="请选择" style="width: 300px;">
              <el-option
                v-for="item in createParam.optionsLT"
                :key="item.id"
                :label="item.type"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="有效期:">
            <el-date-picker
              v-model="createParam.validityTime"
              type="daterange"
              unlink-panels="true"
              range-separator="至"
              start-placeholder="开始"
              end-placeholder="结束"
              value-format="timestamp">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="购买价格(元):">
            <el-input v-model="createParam.totalPayMoney" placeholder="" style="width: 300px;"></el-input>
          </el-form-item>
          <el-form-item label="备注信息:">
            <el-input type="textarea" placeholder="" v-model="createParam.remark" maxlength="30" show-word-limit style="width: 450px;"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleDlgAdd = false">取消</el-button>
        <el-button type="primary" @click="handleCreateOne()">确认添加</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="修改状态"
      :visible.sync="visibleDlgStatu"
      width="50%"
      center>
      <div class="edit-area">
        <el-form label-width="150px">
          <el-form-item label="课程模板:">
            <el-input v-model="updateStatu.lessonTemplateName" placeholder="" style="width: 300px;" :readonly="true"></el-input>
          </el-form-item>
          <el-form-item label="店铺:">
            <el-input v-model="updateStatu.storeFrontName" placeholder="" style="width: 300px;" :readonly="true"></el-input>
          </el-form-item>
          <el-form-item label="状态:">
            <el-select v-model="updateStatu.optionsStatuValue" placeholder="请选择" style="width: 300px;">
              <el-option
                v-for="item in updateStatu.optionsStatu"
                :key="item.id"
                :label="item.value"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleDlgStatu = false">取消</el-button>
        <el-button type="primary" @click="handleupdateStoreLessonuStatu()">确认</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="禁用"
      :visible.sync="visibleDlgProhibit"
      width="50%"
      center>
      <div class="edit-area">
        <el-form label-width="150px">
          <el-form-item label="课程模板:">
            <el-input v-model="prohibitInfo.lessonTemplateName" placeholder="输入账号" style="width: 300px;"></el-input>
          </el-form-item>
          <el-form-item label="店铺:">
            <el-input v-model="prohibitInfo.storeFrontName" placeholder="输入店铺名" :readonly="true" style="width: 300px;"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleDlgProhibit = false">取消</el-button>
        <el-button type="primary" @click="handleProhibit()">禁用</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="启用"
      :visible.sync="visibleDlgInuse"
      width="50%"
      center>
      <div class="edit-area">
        <el-form label-width="150px">
          <el-form-item label="课程模板:">
            <el-input v-model="prohibitInfo.lessonTemplateName" placeholder="输入账号" style="width: 300px;"></el-input>
          </el-form-item>
          <el-form-item label="店铺:">
            <el-input v-model="prohibitInfo.storeFrontName" placeholder="输入店铺名" :readonly="true" style="width: 300px;"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleDlgProhibit = false">取消</el-button>
        <el-button type="primary" @click="handleInUse()">启用</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="续期"
      :visible.sync="visibleDlgrenewal"
      width="50%"
      center>

      <div class="edit-area">
        <el-form label-width="150px">
          <el-form-item label="店铺名:">
            <el-input v-model="renewalParam.storeName" placeholder="" style="width: 300px;" :readonly="true"></el-input>
          </el-form-item>
          <el-form-item label="续期天数:">
            <el-input-number size="medium" v-model="renewalParam.day"></el-input-number>
          </el-form-item>
          <el-form-item label="续费金额(元)::">
            <el-input v-model="renewalParam.pay" placeholder="" style="width: 300px;"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleDlgrenewal = false">取消</el-button>
        <el-button type="primary" @click="handleRenewal() ">续费</el-button>
      </span>
    </el-dialog>
  </div>


</template>
<style scoped>
  /deep/ .el-table th.el-table__cell>.cell{
    width: 90%;
    height: auto;
    background: #ecf3fd;
    border-radius: 8px;
  }
  /deep/ .el-table__header-wrapper .cell{
    line-height: 45px;
    color: #0d6fb8;
  }
  /deep/ .el-dialog--center{
    border: 2px solid #d0d0d0;
    border-radius: 10px;
  }
  /deep/ .el-dialog__header{
    border-radius: 10px;
    background: #f0f7ff;
  }

</style>

<script>
  import {
    createStoreLesson,
    fechListLessonTemplate,
    fechListStoreLesson,
    inuseStoreLesson, prohibitStoreLesson, renewalDaySL, updateStoreLessonuStatu
  } from "../../../api/superAdmin";
  import commonUtils from "../../../utils/commonUtils";
  import {findByAccount} from "../../../api/storeFront";
  import messageUtils from "../../../utils/messageUtils";
  import globaldata from "../../../utils/globaldata";


  export default {
    data() {
      return {

        //弹窗
        visibleDlgAdd:false,
        visibleDlgrenewal:false,
        visibleDlgStatu:false,
        visibleDlgProhibit:false,
        visibleDlgInuse:false,

        lessonTemplates:[],

        //查询参数
        queryParam: {
          storeTemplateId:null,
          storeFrontName: '',

          optionsLTValue:"",
          optionsLT:[],

          //分页查询
          pageNum :1 ,//当前第几页
          totalPage :1, //总共页数
          pageSize : 10,
          pageSizes:[10,20,50,100],
        },

        lessonTemplatArray:[

        ],//课程模板列表

        sliderValue : [0,100],
        sliderMarks: {
          0: '0',
          2000: '2000',
          10000: '1w',
          20000: '2w',
        },
        multipleSelection: [], //选择的表单
        //表单结果
        tableData: [
        ],
        listLoading: true,
        //分页查询
        currentPage :1 ,//当前第几页
        totalPage :1, //总共页数

        seaechStorePhone:'',

        //添加参数
        createParam :{
          storeLessonId:"0",
          account: '',
          storeFrontId:"",
          storeInfo: '无数据',
          validityTime:'',
          totalPayMoney:'',
          remark:'',
          accountId:"",
          storeTitle:'',
          optionsLTValue:"",
          optionsLT:[],


        },

        //续期参数
        renewalParam :{
          id:'0',
          adminId:"",
          day:"0",
          pay:'0'
        },



        updateStatu :{
          id: '0',
          optionsStatuValue:"",
          optionsStatu:[
            {
              id:'0',
              value:"使用"
            },
            {
              id:'-1',
              value:"禁用"
            }
          ]
        },
        prohibitInfo :{
          id: '1',

        },
        handleRemoveStorePicIndex :-1
      }
    },
    created(){
      this.flechList();
      this.getLessonTemplateList();
    },
    mounted() {

    },
    methods: {

      //获取课程模板列表
      getLessonTemplateList(){
        globaldata.getLessonTemplate(this.refreshLessonTemplate);
      },
      refreshLessonTemplate(data){
        this.createParam.optionsLT = [];
        this.queryParam.optionsLT = [];
        var dn = {
          id : null,
          type :'所有'
        }
        this.queryParam.optionsLT.push(dn);
        for (let i = 0;i< data.length;++i){
          var d = {
            id : data[i].id,
            type :data[i].type,
            templateName:data[i].templateName,
          }
          this.queryParam.optionsLT.push(d);
          this.createParam.optionsLT.push(d);
          this.lessonTemplates.push(d);
        }

      },
      flechList(){
        this.listLoading = true;
        let param = {
          storeTemplateId: this.queryParam.optionsLTValue,
          storeFrontName:  this.queryParam.storeFrontName,
          pageNum : this.queryParam.pageNum ,//当前第几页
          pageSize :  this.queryParam.pageSize
        }
        fechListStoreLesson(param).then(response =>
        {
          let date = response.data;
          if (commonUtils.isObjectNull(date)){
            return;
          }
          this.queryParam.totalPage = date.total;
          this.refreshData(date.list);
          this.listLoading = false;
        })
      },

      //刷新页面数据
      refreshData(list){
        if (commonUtils.isObjectNull(list)){
          return;
        }
        let tableDataList = [];
        for (let i = 0;i< list.length;++i){
          let statuDes = "启用";
          if (list[i].statu <0){
            statuDes = "禁用"
          }
          let lessonTemplateName = '无数据';

          for (let j = 0;j< this.lessonTemplates.length;++j){
            console.log(list[i])
            if (list[i].lessonTemplateId == this.lessonTemplates[j].id){
              lessonTemplateName = this.lessonTemplates[j].templateName;
            }
          }

          let data = {
            number : i+1 ,
            id: list[i].id,
            storeFrontName : list[i].title,
            lessonTemplateId : list[i].lessonTemplateId,
            storeFrontId : list[i].storeFrontId,
            lessonTemplateName : lessonTemplateName,
            adminId : list[i].adminId,
            payTime : list[i].payTime,
            validityStartTime : list[i].validityStartTime,
            validityEndTime : list[i].validityEndTime,
            totalPayMoney : list[i].totalPayMoney,
            score : list[i].score,
            statu : list[i].statu,
            statuDes :statuDes,
            remark: list[i].remark,
          };
          tableDataList.push(data);
        }
        this.tableData = tableDataList;
      },

      //点击查询按钮
      onBtnSearch(){
        this.flechList();
      },
      handleCurrentChange(val) {
        this.queryParam.pageNum = val;
        this.flechList();
      },
      handleSizeChange(val) {
        this.queryParam.pageSize = val;
      },


      //添加一个
      handleCreateOneShowDlg(){
        this.visibleDlgAdd = true;
      },
      handleCreateOne(){
        let param = {
          adminId:globaldata.getAdminStore().id,
          storeLessonId:this.createParam.storeLessonId,
          lessonTemplateId:this.createParam.optionsLTValue,
          storeFrontId:this.createParam.storeFrontId,
          validityStartTime:this.createParam.validityTime[0],
          validityEndTime:this.createParam.validityTime[1],
          totalPayMoney:this.createParam.totalPayMoney,
          remark:this.createParam.remark,
        }
        createStoreLesson(param).then(response =>
        {
          let date = response.data;
          if (!commonUtils.isObjectNull(date)){
              messageUtils.successMsg(this,response.message);
          }
          this.visibleDlgAdd = false;
          this.flechList();
        })

      },

      //取消禁用
      showVisibleDlgInUse(index,tableData){
        this.prohibitInfo = {
          id: tableData[index].id,
          lessonTemplateName: tableData[index].lessonTemplateName,
          storeFrontName: tableData[index].storeFrontName
        }
        this.visibleDlgInuse = true;
      },
      handleInUse(){
        let param = {
          id: this.prohibitInfo.id,
          adminId :globaldata.getAdminStore().id
        }
        inuseStoreLesson(param).then(response =>
        {
          let date = response.data;
          if (!commonUtils.isObjectNull(date)) {
            messageUtils.successMsg(this,response.message)
            this.visibleDlgInuse =false;
          }
        })
      },

      showVisibleDlgStatu(index,tableData){
        this.updateStatu = {
          id: tableData[index].id,
          lessonTemplateName: tableData[index].lessonTemplateName,
          storeFrontName: tableData[index].storeFrontName,
          optionsStatu:[
            {
              id:'0',
              value:"使用"
            },
            {
              id:'-1',
              value:"禁用"
            }
          ]
        }

        this.visibleDlgStatu= true;

      },

      handleupdateStoreLessonuStatu(){
        let param = {
          id: this.updateStatu.id,
          adminId :globaldata.getAdminStore().id,
          statu:this.updateStatu.optionsStatuValue
        }
        updateStoreLessonuStatu(param).then(response =>
        {
          let date = response.data;
          if (!commonUtils.isObjectNull(date)) {
            messageUtils.successMsg(this,response.message)
            this.flechList();
            this.visibleDlgStatu =false;

          }
        })
      },

      showVisibleDlgProhibit(index,tableData){
        this.prohibitInfo = {
          id: tableData[index].id,
          lessonTemplateName: tableData[index].lessonTemplateName,
          storeFrontName: tableData[index].storeFrontName
        }
        this.visibleDlgProhibit = true;
      },
      handleProhibit(){
        let param = {
          id: this.prohibitInfo.id,
          adminId :globaldata.getAdminStore().id
        }
        prohibitStoreLesson(param).then(response =>
        {
          let date = response.data;
          if (!commonUtils.isObjectNull(date)) {
            messageUtils.successMsg(this,response.message)
            this.visibleDlgProhibit =false;
          }
        })
      },

      //搜索账号
      handleSearchAccount(){
        let param = {
          account : this.createParam.account,
        }
        findByAccount(param).then(response =>
        {
          let date = response.data;
          if (!commonUtils.isObjectNull(date)){
            this.createParam.storeFrontId =date.id;
            this.createParam.storeTitle =date.title;
          }else {
            this.createParam.storeFrontId =  null;
            this.createParam.storeTitle ="无数据";
          }

        })
      },


      handleProhibit(){
        this.visibleDlgProhibit = false;
      },


      showVisibleDlgrenewal(index,tableData){
        this.renewalParam.id=  tableData[index].id;
        this.renewalParam.storeName=  tableData[index].storeFrontName;
        this.visibleDlgrenewal= true;
      },
      handleRenewal(){
        let param = {
          id:this.renewalParam.id,
          adminId:globaldata.getAdminStore().id,
          day:this.renewalParam.day,
          pay:this.renewalParam.pay,
        }
        renewalDaySL(param).then(response =>
        {
          let date = response.data;
          if (!commonUtils.isObjectNull(date)) {
            messageUtils.successMsg(this,response.message)
            this.visibleDlgrenewal =false;
          }
        })

      },

    }
  }
</script>






// WEBPACK FOOTER //
// src/views/superadmin/lesson-manager/index.vue